import { FunctionComponent, useEffect, useState } from 'react';
import { PendingInvite } from '../../types/general';
import { PendingInvitesList } from './PendingInvitesList';
import { UserContext, withUserContext } from '../controllers/UserContext';
import { UserInvite } from '../../types/user';

type BaseProps = UserContext;

const HomePendingInvitesBase: FunctionComponent<BaseProps> = (props) => {
    const {
        getUserPendingInvites,
    } = props;

    const [invites, setInvites] = useState<PendingInvite[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [cursor, setCursor] = useState('');

    useEffect(() => {
        getInvitesList(true);
    }, []);

    const getInvitesList = async (reset?: boolean) => {
        setIsLoading(true);
        const params = {
            _cursor: reset ? '' : cursor,
        };
        const invitesData = await getUserPendingInvites(params);

        const transformedInvitesData = invitesData.results
            .map((userInvite: UserInvite) => {
                const inviteId = `${userInvite.inviteType ?? 'unknown'}-${userInvite.id}-${userInvite.inviteToken ?? ''}`;
                return {
                    id: inviteId,
                    inviteType: userInvite.inviteType,
                    inviteToken: userInvite.inviteToken ?? '',
                    inviteExpiresAt: userInvite.expirationDate,
                    resourceTitle: userInvite.title ?? '',
                    resourceType: userInvite.type ?? null,
                };
            });
        const uniqueInvitesData = Array.from(
            new Map(transformedInvitesData.map((invite) => [invite.id, invite])).values(),
        );
        if (reset) {
            setInvites(uniqueInvitesData);
        } else {
            setInvites((prev) => {
                const mergedInvites = [...prev, ...uniqueInvitesData];
                return Array.from(new Map(mergedInvites.map((invite) => [invite.id, invite])).values());
            });
        }

        setCursor(invitesData.cursor);
        setIsLoading(false);
    };
    return (
        <>
            {invites.length > 1 && (
                <PendingInvitesList
                    pendingInvites={invites}
                    hasMore={!!cursor}
                    requestMore={getInvitesList}
                    isLoading={isLoading}
                    moreElementPerScroll
                />
            )}
        </>
    );
};

export const HomePendingInvites = withUserContext(HomePendingInvitesBase);
